<div [ngClass]="{ 'lr_overlay': true, 'lr_overlay_gray': overlayIsGray, 'lr_overlay_inline': isInline }" *ngIf='isVisible'>
    <div class="lr_container" [style.height]="height + 'px'" [style.backgroundColor]="backgroundColor">
        <div class="lr_text">{{displayText}}</div>
        <div class="lr_loader" [style.height]="(height * 0.8) + 'px'" [style.width]="(height * 0.8) + 'px'">
            <svg viewBox="25 25 50 50">
                <circle class="lr_circle" cx="50" cy="50" r="20" fill="none"></circle>
            </svg>
        </div>
    </div>
</div>